import { httpClient } from '../http/httpClient'

export interface RecoveryCodeResponse {
  success: boolean
  token: string
}

export interface RecoveryCodeParams {
  cpf: string
  code: string
}

export const recoveryCode = async (params: RecoveryCodeParams) => {
  const { data } = await httpClient.post<RecoveryCodeResponse>(
    'auth/validate-code',
    params,
  )
  return data
}
